import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import it from "./locales/it.json";
import en from "./locales/en.json";
import de from "./locales/de.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";
import pl from "./locales/pl.json";
import { initialLang } from "../lib/langDetect";

export const LANGUAGES = [
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "pl", label: "Polski", flag: "🇵🇱" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // No saved preference → best match for the browser's Accept-Language,
    // English when nothing matches (crawlers keep Italian, see langDetect).
    fallbackLng: "en",
    lng: initialLang(),
    supportedLngs: ["it", "en", "de", "fr", "es", "pl"],
    debug: false,
    interpolation: { escapeValue: false },
    resources: {
      it: { translation: it },
      en: { translation: en },
      de: { translation: de },
      fr: { translation: fr },
      es: { translation: es },
      pl: { translation: pl },
    },
    detection: {
      order: ["querystring", "localStorage", "navigator"],
      lookupQuerystring: "lang",
      caches: ["localStorage"],
      lookupLocalStorage: "mtt_lang",
    },
  });

// Keep <html lang> in sync everywhere (public pages also update it via useDocumentMeta)
i18n.on("languageChanged", (lng) => {
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("lang", (lng || "it").split("-")[0]);
  }
});

// Initial value too: pages without useDocumentMeta (login, register, app)
// would otherwise keep the `lang="it"` baked into index.html.
if (typeof document !== "undefined") {
  document.documentElement.setAttribute("lang", (i18n.language || "it").split("-")[0]);
}

export default i18n;
